import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TState } from 'redux/config/root-types'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { useTranslation } from 'react-i18next'
import { I18nModal } from 'utils/i18n/i18nModal'
import { makeStyles } from 'tss-react/mui'
import { Actions_PromoCode } from 'redux/modules/promoCode/Actions'

export const usePromoCodeTrailerTypeFilter = () => {
  const { t } = useTranslation(I18nModal.trailerTypeFilter)
  const dispatch = useDispatch()
  const { classes } = useStyles()

  const data = useSelector(({ trailerTypes }: TState) => trailerTypes.data)
  const isLoading = useSelector(({ trailerTypes }: TState) => trailerTypes.isLoading)
  const initialCheckedIds = useSelector(({ promoCode }: TState) => promoCode.selectedTrailerTypeIds)

  const [checkedIds, setCheckedIds] = useState(initialCheckedIds)

  const handleToggle = (value: number) => () => {
    const currentIndex = checkedIds.indexOf(value)
    const newCheckedIds = [...checkedIds]

    if (currentIndex === -1) {
      newCheckedIds.push(value)
    } else {
      newCheckedIds.splice(currentIndex, 1)
    }

    setCheckedIds(newCheckedIds)
  }

  const isSelectAll = checkedIds.length === data?.length

  const handleToogleAll = () => {
    if (isSelectAll) {
      setCheckedIds([])
    } else {
      const allIds = data?.map(({ type }) => type.id) || []
      setCheckedIds(allIds)
    }
  }

  const onSubmit = () => {
    dispatch(Actions_PromoCode.store.changeSelectedTrailerTypesIds(checkedIds))
    dispatch(Actions_Modals.store.hideModal())
  }

  const closeModal = () => {
    dispatch(Actions_Modals.store.hideModal())
  }

  return {
    t,
    classes,
    closeModal,
    isLoading,
    onSubmit,
    data: data || [],
    checkedIds,
    isSelectAll,
    handleToggle,
    handleToogleAll,
  }
}

const useStyles = makeStyles()((theme) => ({
  card: {
    width: 375,
    overflowY: 'auto',
    maxHeight: '100%',
  },
  list: {
    overflow: 'auto',
    maxHeight: 300,
  },
  listItemText: {
    // ...theme.typography.body1, TODO:
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    color: theme.typography.body1.color,
  },
  cancel: {
    margin: '0.875em 0',
  },
}))
